var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3972 0.928711H4.61827C2.33284 0.928711 0.899902 2.54381 0.899902 4.83033V10.9984C0.899902 13.285 2.32616 14.9001 4.61827 14.9001H11.1765C13.4694 14.9001 14.8956 13.285 14.8956 10.9984V8.01009",
    stroke: "#178477",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41706 6.96204L10.9712 1.41786C11.6631 0.7279 12.7847 0.7279 13.4766 1.41786L14.3811 2.32075C15.0731 3.01145 15.0731 4.13171 14.3811 4.82167L8.80023 10.3926C8.49774 10.6945 8.08747 10.8644 7.65937 10.8644H4.87524L4.94511 8.06004C4.95551 7.64755 5.12423 7.25435 5.41706 6.96204Z",
    stroke: "#178477",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.127 2.27441L13.5205 5.6619",
    stroke: "#178477",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit-square.acb9b94363e189cf38dd15d2a68a057a.svg";
export { ForwardRef as ReactComponent };